import { MaterialCommunityIcons } from "@expo/vector-icons";
import { Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";

type StreakCellProps = {
	day: string;
	status: "completed" | "missed" | "unattempted";
	isToday: boolean;
};

export const StreakCell = ({ day, status, isToday }: StreakCellProps) => {
	const theme = useAppTheme();

	const CELL_SIZE = 40;
	const GAP = 4;
	const TODAY_DOT_SIZE = 5;
	const TODAY_DOT_TOP_OFFSET = -13;

	const getStatusStyle = () => {
		switch (status) {
			case "completed":
				return {
					backgroundColor: theme.colors.primary,
					icon: "check" as const,
					iconColor: theme.colors.onPrimary,
				};
			case "missed":
				return {
					backgroundColor: theme.colors.inversePrimary,
					icon: "close" as const,
					iconColor: theme.colors.onPrimary,
				};
			default:
				return {
					backgroundColor: "transparent",
					borderColor: theme.colors.inversePrimary,
					borderWidth: 2,
					icon: null,
				};
		}
	};

	const statusStyle = getStatusStyle();

	const getDayLabelColor = () => {
		if (status === "unattempted") {
			return theme.colors.primary;
		}
		return theme.colors.inverseSurface;
	};

	return (
		<Box alignItems="center" gap={GAP} style={{ width: CELL_SIZE }}>
			<Box
				alignItems="center"
				justifyContent="center"
				style={{
					position: "relative",
					width: CELL_SIZE,
					height: CELL_SIZE,
				}}
			>
				{isToday && (
					<Box
						style={{
							position: "absolute",
							top: TODAY_DOT_TOP_OFFSET,
							width: TODAY_DOT_SIZE,
							height: TODAY_DOT_SIZE,
							borderRadius: TODAY_DOT_SIZE / 2,
							backgroundColor: theme.colors.inverseSurface,
						}}
					/>
				)}

				<Box
					alignItems="center"
					justifyContent="center"
					style={{
						width: CELL_SIZE,
						height: CELL_SIZE,
						borderRadius: CELL_SIZE / 2,
						backgroundColor: statusStyle.backgroundColor,
						borderWidth: statusStyle.borderWidth,
						borderColor: statusStyle.borderColor,
					}}
				>
					{statusStyle.icon && (
						<MaterialCommunityIcons
							name={statusStyle.icon}
							size={24}
							color={statusStyle.iconColor}
						/>
					)}
				</Box>
			</Box>

			<Text
				variant="bodySmall"
				style={{
					color: getDayLabelColor(),
					fontWeight: isToday ? "700" : "400",
				}}
			>
				{day}
			</Text>
		</Box>
	);
};
